import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { partnerApi, type Partner } from '../lib/api';
import { Sidebar } from './Sidebar';
import { appRoutes } from '../app-routes';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const { data: partner } = useQuery<Partner>({
    queryKey: ['partner'],
    queryFn: () => partnerApi.getPartner(),
  });

  const getActiveSidebarItem = () => {
    if (location.pathname.startsWith('/dashboard/metrics')) return 'metrics';
    if (location.pathname.startsWith('/dashboard/tenants')) return 'tenants';
    if (location.pathname.startsWith('/dashboard/users')) return 'users';
    if (location.pathname.startsWith('/dashboard/communications')) return 'communications';
    if (location.pathname.startsWith(appRoutes.ENGAGE_SETUP)) return 'engage';
    if (location.pathname.startsWith('/dashboard/acquire')) return 'acquire';
    if (location.pathname.startsWith('/dashboard/measure')) return 'measure';
    if (location.pathname.startsWith('/dashboard/reputation')) return 'reputation';
    if (location.pathname.startsWith(appRoutes.VOICE)) return 'voice';
    if (location.pathname.startsWith(appRoutes.AI_AGENTS)) return 'ai-tools';
    if (location.pathname.startsWith(appRoutes.AGENTS)) return 'agents';
    if (location.pathname === '/dashboard/settings/team') return 'team';
    if (location.pathname === '/dashboard/settings') return 'profile';
    if (location.pathname === '/dashboard/settings/api') return 'api-keys';
    if (location.pathname === '/dashboard/settings/theme') return 'branding';
    if (location.pathname.startsWith('/dashboard/settings/data-integration')) return 'data-integration';
    return 'metrics';
  };

  return (
    <div className={styles.layout}>
      <Sidebar activeItem={getActiveSidebarItem()} partner={partner} />
      <main className={styles.main}>
        <div className={styles.content}>{children}</div>
      </main>
    </div>
  );
};
